import { CanActivateFn, Router } from '@angular/router';
import { AuthenticationService } from '../services/authentication';
import { inject } from '@angular/core';

export const authGuard: CanActivateFn = (route, state) => {
  const redirectToLogin = () => inject(Router).createUrlTree(['login']);

  return inject(AuthenticationService).isLoggedIn() ? true : redirectToLogin();
};
